import { render, staticRenderFns } from "./WeightIcon.vue?vue&type=template&id=ed103780"
import script from "./WeightIcon.vue?vue&type=script&lang=js"
export * from "./WeightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports